<template>
  <Grid :col="cols">
    <component
      :is="thumb()"
      v-for="item in items"
      :key="item"
      :class="['skeleton', `skeleton--${thumbComponent}`]"
      :data="{
        link: '#!',
        title: {
          rendered: ''
        },
        acf: {
          template: 'default'
        }
      }"
      :thumb="thumbTheme"
    />
  </Grid>
</template>

<script>
import Thumb from '@/components/thumb/';
import ThumbProduct from '@/components/thumb/product';

const thumbs = new Map();
thumbs.set('post', Thumb);
thumbs.set('posts', Thumb);
thumbs.set('product', ThumbProduct);
thumbs.set('products', ThumbProduct);

export default {
  name: 'Skeleton',
  props: {
    thumbTheme: {
      type: String,
      default: 'default',
    },
    thumbComponent: {
      type: String,
      default: 'default',
    },
    items: {
      type: Number,
      required: true,
    },
    cols: {
      type: Object,
      default: () => ({
        default: 12,
        m: 4,
      }),
    },
  },
  methods: {
    thumb() {
      return thumbs.get(this.thumbComponent);
    },
  },
};
</script>

<style lang="scss">
.skeleton {
  pointer-events: none;
  cursor: default;
  background: var(--white);

  * {
    cursor: default !important;
    pointer-events: none !important;
    visibility: hidden !important;
  }
}
</style>
